const termsOfService = {
  title: 'Terms of Service',
  description:
    'Please review and accept our terms of service to continue using the app.',
  summaryTitle: 'Key points:',
  titleLine1: 'Designed for Clinical Use',
  summaryLine1:
    'This tool is intended for use by qualified medical and healthcare professionals.',
  titleLine2: 'Independent verification required',
  summaryLine2:
    'This tool uses artificial intelligence, which can make errors. You must review and verify all outputs independently.',
  titleLine3: 'User responsibility',
  summaryLine3:
    'You, the user, assume full responsibility for the accuracy of medical reports and other content created using this tool.',
  description1: 'By continuing, you are agreeing to the full ',
  linkHref: 'https://medical.voicefill.ai/terms-and-conditions.html',
  linkText: 'terms of service',
  description2: '.',
  acceptTerms: 'I agree',
};

export default termsOfService;
